const whatIfHu = {
	whatIfGroupTable: 'What if group',
	whatIfGroupEditForm: 'What if group',
	whatIfTable: 'What if',
	whatIfExpertTable: 'What if',
	whatIfEditForm: 'What if',
	name: 'Név',
	created: 'Létrehozva',
	updated: 'Módosítva',
	back: 'Vissza',
	save: 'Mentés',
	cancel: 'Mégse',
	properties: 'Tulajdonságok',
	circleProperties: 'Kör tulajdonságok',
	deviceProperties: 'Eszköz tulajdonságok',
	labelProperties: 'Cimke tulajdonságok',
	rectProperties: 'Téglalap tulajdonságok',
	whatIfName: 'What If neve',
	saveSuccessful: 'Sikeres mentés',
	saveFailed: 'Hiba történt a mentés során, minden adat megadása kötelező vagy a név már használatban van',
	move: 'Mozgatás',
	resize: 'Átméretezés',
	rotate: 'Forgatás',
	mirror: 'tükrözés',
	devices: 'Eszközök',
	line: 'Vonal',
	delete: 'Törlés',
	label: 'Cimke',
	pump: 'Szivattyú',
	compressor: 'Kompresszor',
	airCooler: 'Léghűtő',
	furnace: 'Csőkemence',
	heatExchanger: 'Hőcserélő',
	distillationColumn: 'Desztillációs oszlop',
	circle: 'Kör',
	fillColorLabel: 'Kitöltési szín',
	fillLabel: 'Kitöltés',
	borderColorLabel: 'Keretszín',
	backgroundColorLabel: 'Háttérszín',
	fontColorLabel: 'Betűszín',
	color_black: 'Fekete',
	color_white: 'Fehér',
	color_darkRed: 'Piros',
	color_darkGreen: 'Zöld',
	color_darkBlue: 'Kék',
	fontSize: 'Betűméret',
	value: 'Érték',
	justALabel: 'Csak egy címke',
	imageProperties: 'Kép tulajdonságok',
	imageKey: 'Kép',
	image: 'Kép',
	none: 'Nincs',
	'group.name': 'Group',
	group: 'User group',
	decimalPlaces: 'Decimal places',
	thousandsSeparator: 'Thousands separator',
	displayAsPercentage: 'Display as percentage',
	workflow: 'Workflow',
	valueKey: 'Value key',
	type: 'Type',
	variable: 'Variable value',
	dict: 'Dict value',
	showUnit: 'Show unit',
	sumTable: 'Summary table',
	sumTableProperties: 'Summary table properties',
	minMax: 'Min/Max',
	documentProperties: 'Dokumentumok tulajdonságai',
	revision: 'Revízió',
	'creator.name': 'Feltöltő',
	file: 'Fájl',
	close: 'Bezár',
	visible: 'Látható',
	document: 'Document',
	note: 'Note',
	noteProperties: 'Note Properties',
	noteNoContent: 'Nincs tartalom',
	noteUnknownCreator: 'Ismeretlen felhasználó',
	notesLoading: 'Jegyzetek betöltése...',
	notesLoadFailed: 'A jegyzeteket nem sikerült betölteni.',
	notesEmpty: 'Még nincsenek jegyzetek.',
	notesSaveWhatIfFirst: 'Jegyzet hozzáadása előtt mentse a What If-et.',
	noteCommentLabel: 'Megjegyzés',
	noteCommentPlaceholder: 'Írja ide a megjegyzést',
	noteSaveFailed: 'A jegyzetet nem sikerült menteni.',
	sendNote: 'Jegyzet küldése',
	retry: 'Újrapróbálás',
	state: 'State',
	values: 'Values',
	reader: 'Reader',
	'aspect.name': 'Aspect',
	'transformer.name': 'Transformer',
	transformer: 'Transformer',
	aspect: 'Aspect',
	icon: 'Ikon',
	iconSize: 'Ikonméret',
	showLabel: 'Címke látszik',
	input: 'Input',
	output: 'Output',
	tableInDialog: 'Táblázat megjelenítése ablakban',
	container: 'Konténer',
	containerProperties: 'Konténer tulajdonságok',
	figureNameNotUnique: 'Konténer neve nem egyedi',
	linkTo: 'Hivatkozás egy másik What if-re',
	linkToDialog1: 'Most átleszel irányítva a következő What if-re:',
	linkToDialog2: 'A mentetlen adatok elvesznek. Folytatja?',
	linkToError: 'Hivatkozott What If hiányzik vagy törölve lett.',
	measurement: 'Measurement',
	piMeasurementReader: 'PI Measurement Reader',
	labMeasurementReader: 'Lab Measurement Reader',
	piAfEventReader: 'PI AF eseményolvasó',
	diffEpsilonValue: 'Difference epsilon value',
	diffEpsilonPercent: 'Difference epsilon percentage',
	o_clipboard: 'Copy to Clipboard',
	to_clipboard_short: 'Copy',
	to_clipboard_successful: 'Data copied to clipboard',
	to_clipboard_failed: 'Error copying to clipboard',
	from_clipboard: 'Paste from Clipboard',
	from_clipboard_short: 'Paste',
	from_clipboard_successful: 'Data successfully pasted from clipboard',
	from_clipboard_failed: 'Paste from clipboard failed, please check the data'
};

export default whatIfHu;
